import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toast" }
const _hoisted_2 = ["element-loading-text"]


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
  visible: Boolean,
  text: String,
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "content",
      "element-loading-text": props.text,
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.7)"
    }, null, 8, _hoisted_2), [
      [_directive_loading, props.visible]
    ])
  ], 512)), [
    [_vShow, props.visible]
  ])
}
}

})